const ImpactStats = [
  {
    id: 1,
    value: '99.9%',
    label: 'Uptime on real-time campaign pipelines',
  },
  {
    id: 2,
    value: '40%',
    label: 'Improvement in data accuracy',
  },
  {
    id: 3,
    value: '35%',
    label: 'Boost in backend/frontend performance',
  },
  {
    id: 4,
    value: '25%',
    label: 'Increase in team productivity',
  },
];

export default ImpactStats;
